<template>
    <div v-if="show" class="fixed inset-0 bg-neutral-900	bg-opacity-10">
        
        <div class="h-[21rem] w-96 absolute inset-0 m-auto bg-white border rounded">
            <div class="flex px-3 py-2 border border-b-1 border-t-0 border-x-0	">
                <h1 class="flex-1">New Feed Source</h1>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" @click.stop="close"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </div>

            <div v-if="loading" class="text-center bg-white p-12 m-2">
                <svg  aria-hidden="true" class="w-8 h-8 m-auto text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#e5e7eb"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
            </div>
            
            <div v-else class="p-5">

                <div class="mt-4">
                    <label for="Link">Title</label>
                    <input name="Link" type="text"  placeholder=""  v-model="feedProcessor.title"
                    class="py-2 px-3 w-full  bg-white line-height-5 rounded-md border border-gray-300">
                </div>

                
                <div class="mt-4">
                    <label for="Link">Link</label>
                    <input name="Link" type="text" placeholder=""  v-model="feedProcessor.link" @input="checkLink()"
                    class="py-2 px-3 w-full  bg-white line-height-5 rounded-md border border-gray-300">
                    <span class="text-sm">Please note, provocative content is not allowed.</span>
                </div>

                <div  class="flex">
                    
                    <button :disabled="loading" @click="close"
                    class="cursor-pointer rounded-md mt-6 line-height-5 border mx-1
                    bg-white py-2 px-4 w-full font-weight-bold m-auto ">Cancel</button>

                    <button :disabled="loading" @click="addFeedProcessor"
                    class="cursor-pointer text-white rounded-md mt-6 line-height-5 mx-1
                    bg-gray-700 py-2 px-4 w-full font-weight-bold m-auto ">
                        Save
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
  
<script>
    
export default {
    name: 'NewFeedSource',
    props:['confirmedFun'],
    components: {

    },
    async mounted(){

    },
    data () {
        return {
            show:false,
            query:{},
            loading:false,
            feedProcessor:{
                title:'',
                link:''
            }
        }
    }, 
    methods: {
        open:function(query){
            this.show=true;
            this.feedProcessor = {}
            this.feedProcessor.title = `New Feed source (${query.feedProcessorsLength + 1 })` 
        },
        close:function(e){
            this.show=false;
        },
        async addFeedProcessor(){
            
            if(!this.feedProcessor.title){return this.$store.state.toastr.open({timeOut:5000, 
                type:"error", title:'Failed', text: 'Please enter feed source title'});}

            if(!this.feedProcessor.link){return this.$store.state.toastr.open({timeOut:5000, 
                type:"error", title:'Failed', text: 'Please enter feed source link'}); }

            if(this.checkLink()){return;}

            this.loading = true;
            const res = await this.$store.state.axiosInstance.post(this.$store.state.API_ENDPOINT + '/v1/feedProcessor', 
            this.feedProcessor ,{
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            this.loading = false;
            
            if(res.data && res.data.success){
                this.$store.state.toastr.open({timeOut:5000, type:"success", 
                title:'Success ', text: 'Feed source added successfully'});
                this.close();
                this.confirmedFun();
            }else {
                this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Failed ', text: res.data.message || 'Failed to add feed source'});
            } 
        },
        checkLink(){
            try {
                if(!this.feedProcessor.link){ return true;}
                const myUrl = new URL(this.feedProcessor.link)
                const arr = [
                    'twitter.com','x.com','facebook.com',
                    'reddit.com','instagram.com', 'youtube.com',
                    'linkedin.com'
                ];
                let validURL = arr.some(x=>myUrl.hostname.includes(x));
                if(!validURL){
                    return this.$store.state.toastr.open({timeOut:5000, type:"error", 
                    title:'Failed ', text: 'Feed source link not supported'});
                }
                return false;
            } catch (e){
                return this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Failed ', text: 'invaild link'});
            }
            
      }
    }
}
</script>
 
<style>
 
</style>



// WEBPACK FOOTER //
// src/components/NewFeedSource.vue